import { useTranslation } from 'react-i18next'

import { TimerIcon } from '@phosphor-icons/react'

import { transactionsAnalyticsStatsValues } from '@reveni-io/reveni-ui'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import { statisticStatuses } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'

const AboutToExpire = ({ expired, onClick }) => {
  const { t } = useTranslation()

  return (
    <Statistic
      size="small"
      isOutlined={false}
      status={statisticStatuses.danger}
      Icon={TimerIcon}
      label={t('A punto de expirar')}
      value={<AnimatedNumber target={expired} format="decimal" />}
      showStatusIcon
      onClick={() => onClick(transactionsAnalyticsStatsValues.aboutToExpire)}
    />
  )
}

export default AboutToExpire
